<ngx-loading [show]="loading"></ngx-loading>

<div id="wrapper" #wrapper>
  <div>
    <div>
      <div>
        <app-flag-manger-header
          [inspection]="inspection"
          [statuses]="statuses"
          [underwritingStatus]="underwritingStatus"
          (statusChange)="underwritingStatus = $event"
          [showReportButton]="showReportButton()"
          (flagRefresh)="flagRefresh($event)"
          (refreshInspection)="inspection = $event"
          (openLetterHistory)="showLetterHistoryPanel = true"></app-flag-manger-header>
      </div>
    </div>
  </div>
  <div class="main">
    <div id="left-column">
      <app-flag-manager-sidebar
        [statuses]="statuses"
        [groups]="groups"
        [selectedGroup]="selectedGroup"
        [underwritingStatus]="underwritingStatus"
        [inspectionId]="inspection?.id"
        [countUncategorized]="countUncategorized"
        (openSelectedGroup)="openGroup($event)"
        (flagDropped)="onFlagDropped($event)"
        (dropReverted)="onDropReverted()"
        (groupsReordered)="groups = $event"
        (showComments)="openCommentsModal()"
        (setIssueNo)="issueNo = $event"
        [comments]="this.allCommentsLength ? this.allCommentsLength : '0'"
        (removeGroup)="removeGroup($event)"
        (createGroup)="CreateGroupFromSidebar($event)"
        (openGroupModal)="openSidebarGroupModal()"></app-flag-manager-sidebar>
    </div>
    <div id="right-column">
      <app-flag-manager-full-view
        [group]="selectedGroup"
        [currentFlags]="currentFlags"
        [inspection]="inspection"
        [allFlags]="allFlags"
        [underwritingStatus]="underwritingStatus"
        [issueNo]="issueNo"
        [selectedTab]="selectedTab"
        [tabsCount]="tabsCount"
        (editGroup)="openEditGroupModal()"
        (selectedFlagsChange)="onSelectedFlagsChange($event)"
        (flagStatusChanged)="onFlagStatusChanged($event)"
        (flagIgnored)="onFlagIgnored($event)"
        (selectedTabChange)="selectedTabChange($event)"
        (resolveBarTabChange)="resolveBarTabChange($event)"
        (reSeparateGroups)="reSeparateGroups($event)"
        (flagReordered)="onFlagReordered()"></app-flag-manager-full-view>
    </div>
  </div>

  <app-flag-management-bar
    *ngIf="!editGroup"
    [selectedFlagIds]="selectedFlagIds"
    [selectedGroup]="selectedGroup"
    [underwritingStatus]="underwritingStatus"
    [allFlags]="allFlags"
    [inspection]="inspection"
    [groups]="groups"
    [managingGroups]="managingGroups"
    (showGroupTemplate)="openFlagGroupTemplateModal(false)"
    [resolveBarSelectedTab]="resolveBarSelectedTab"
    (changeFlagStatusBulk)="changeFlagStatusBulk($event)"
    [shouldShowResolveOptions]="shouldShowResolveOptions"
    (createGroup)="createGroup($event)"
    (ignoreFlags)="excludeFlags()"
    (keepFlags)="includeFlags()"
    (ungroupFlags)="ungroupFlags()"
    (mergeInGroup)="mergeSelectedFlagsIntoGroup($event)"
    (extensionGrantedDeadlines)="load()"
    [selectedTab]="selectedTab">
  </app-flag-management-bar>

  <app-flag-group-template
    #flagGroupTemplateModal
    [flagGroupTags]="flagGroupTags"
    [inspectionId]="inspection?.id"
    [createGroup]="canCreateGroup"
    [expand]="false"
    (messageEvent)="createGroup($event)"
    (editGroup)="editGroupByTemplate($event)"
    [group]="selectedGroup"
    (cancelFromEdit)="onCancelFromEditTemplate()">
  </app-flag-group-template>

  <app-group-name-modal
    #sidebarGroupNameModal
    (createGroup)="CreateGroupFromSidebar($event)"
    (showGroupTemplate)="openFlagGroupTemplateModal(true)">
  </app-group-name-modal>

  <app-group-management-bar
    [groups]="groups"
    (removeGroups)="removeSelected($event)"
    (mergeGroups)="mergeGroups($event)"></app-group-management-bar>
</div>

<app-inspection-comments
  #commentsModal
  *ngIf="inspection && answers"
  [inspection]="inspection"
  [answers]="answers"
  (allCommentsLength)="allCommentsLength = $event"></app-inspection-comments>

<app-flag-manager-edit-group
  #editGroupModal
  [group]="selectedGroup"
  [readOnly]="isReadonly()"
  (groupSaved)="groupSaved($event)"
  (showGroupTemplate)="openFlagGroupEditTemplateModal(false)">
</app-flag-manager-edit-group>

<app-flag-unlink-confirm-modal #unlinkConfirm></app-flag-unlink-confirm-modal>

<app-letter-history-panel
  *ngIf="inspection"
  [inspection]="inspection"
  [isVisible]="showLetterHistoryPanel"
  (closePanel)="showLetterHistoryPanel = false">
</app-letter-history-panel>
